const pouchandgo = {
    id: 'pouchandgo',
    publicSiteName: 'Pouch and Go',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#CB0F6F',
            secondary: '#000000',
            color1: '#FF0A8A',
            color2: '#B7F500',
            color3: '#FFFFFF',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '16px',
        header: {
            layout: 'minimal',
            dark: true,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/pouchandgo/favicon.ico',
        logo: '/pouchandgo/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default pouchandgo